import type { Webhook } from 'api';

export const webhookLabel = (webhook: Webhook) =>
  `${webhook.event} — ${webhook.destination_url ?? '—'}`;
